var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _g2, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 152,
    viewBox: "0 0 202 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.26 59.7612C169.95 59.7626 169.643 59.8171 169.351 59.9225C169.492 59.4719 169.563 59.0028 169.563 58.5309C169.524 57.3371 169.021 56.2054 168.161 55.3749C167.301 54.5444 166.152 54.0801 164.955 54.0801C163.759 54.0801 162.609 54.5444 161.749 55.3749C160.89 56.2054 160.387 57.3371 160.347 58.5309C160.347 58.657 160.347 58.773 160.347 58.894C159.877 58.6568 159.359 58.5325 158.832 58.5309C157.947 58.5309 157.098 58.8821 156.472 59.5071C155.846 60.132 155.494 60.9797 155.494 61.8636C155.494 62.7475 155.846 63.5951 156.472 64.2201C157.098 64.8451 157.947 65.1962 158.832 65.1962H170.235C170.957 65.1962 171.649 64.9099 172.16 64.4003C172.67 63.8907 172.957 63.1994 172.957 62.4787C172.957 61.758 172.67 61.0667 172.16 60.5571C171.649 60.0475 170.957 59.7612 170.235 59.7612H170.26Z",
    fill: "#DDDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M137.173 36.7686C136.875 36.7692 136.58 36.8204 136.299 36.9199C136.436 36.4875 136.505 36.037 136.507 35.5838C136.507 34.4111 136.04 33.2864 135.209 32.4572C134.379 31.628 133.252 31.1621 132.078 31.1621C130.903 31.1621 129.777 31.628 128.946 32.4572C128.115 33.2864 127.649 34.4111 127.649 35.5838C127.649 35.7048 127.649 35.8157 127.649 35.9317C127.217 35.7103 126.74 35.5899 126.254 35.5795C125.768 35.5691 125.287 35.669 124.845 35.8716C124.404 36.0743 124.015 36.3743 123.706 36.7492C123.398 37.1241 123.179 37.564 123.066 38.0356C122.953 38.5073 122.949 38.9984 123.054 39.472C123.159 39.9455 123.37 40.389 123.672 40.7691C123.974 41.1491 124.358 41.4558 124.796 41.6659C125.234 41.876 125.714 41.984 126.199 41.9819H137.153C137.506 41.9974 137.858 41.9414 138.189 41.8172C138.519 41.6931 138.821 41.5034 139.076 41.2596C139.332 41.0158 139.535 40.7229 139.673 40.3986C139.812 40.0743 139.884 39.7254 139.884 39.3727C139.884 39.0201 139.812 38.6711 139.673 38.3468C139.535 38.0226 139.332 37.7297 139.076 37.4859C138.821 37.2421 138.519 37.0524 138.189 36.9282C137.858 36.8041 137.506 36.7481 137.153 36.7636L137.173 36.7686Z",
    fill: "#DDDBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M39.3397 128.188C39.3397 128.188 17.3469 102.117 28.3458 69.5669C39.3447 37.0169 72.3313 13.8194 114.196 21.5485C156.06 29.2777 188.774 48.9458 160.014 128.032L39.3397 128.188Z",
    fill: "#DDDBDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.712 92.4824H143.229V127.12H161.712V92.4824Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.75 71.1855H112.372V127.115H122.75V71.1855Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.666 57.9863H98.4395V127.12H110.666V57.9863Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.959 54.0117H100.5V57.9847H108.959V54.0117Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.757 50.5293H101.712V54.0082H107.757V50.5293Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3489 52.2676H71.5986V127.119H94.3489V52.2676Z",
    fill: "#E6E6E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9354 50.5293H75.0127V54.0082H90.9354V50.5293Z",
    fill: "#E6E6E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5425 30.2109H82.4062V50.5295H83.5425V30.2109Z",
    fill: "#E6E6E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2358 40.3691H40.9502V128.253H63.2358V40.3691Z",
    fill: "#E6E6E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.229 101.541H86.1787V127.118H143.229V101.541Z",
    fill: "#E6E6E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2866 36.5781H42.8945V40.8939H61.2866V36.5781Z",
    fill: "#E6E6E6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M170.084 126.146H25.0883C23.4846 126.146 22.1846 127.444 22.1846 129.046C22.1846 130.647 23.4846 131.945 25.0883 131.945H170.084C171.688 131.945 172.988 130.647 172.988 129.046C172.988 127.444 171.688 126.146 170.084 126.146Z",
    fill: "#003353"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M123.957 113.225H94.1924V126.096H123.957V113.225Z",
    fill: "#003353"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M123.957 115.256H94.1924V116.678H123.957V115.256Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.575 113.223H103.581L106.556 40.8932L106.586 40.1621H111.57L114.075 101.108L114.575 113.223Z",
    fill: "#003353"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M114.338 107.462L114.575 113.225H103.581L106.556 40.8945L106.601 40.9248C106.803 99.5008 114.338 107.462 114.338 107.462Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M111.353 119.658H106.803V126.092H111.353V119.658Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.075 33.3066L110.61 38.0107H115.564L111.555 40.9198L113.09 45.6289L109.075 42.7197L105.065 45.6289L106.601 40.9198L102.591 38.0107H107.545L109.075 33.3066Z",
    fill: "#FFD200"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0922 110.088H50.6367V126.096H92.0922V110.088Z",
    fill: "#00A0F3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3958 97.2461H56.3281V110.088H86.3958V97.2461Z",
    fill: "#00A0F3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8295 95.0527H58.8926V97.2459H83.8295V95.0527Z",
    fill: "#00A0F3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M83.8295 95.0527H58.8926V97.2459H83.8295V95.0527Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M58.3583 114.727H54.7324V121.669H58.3583V114.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M64.287 114.727H60.6611V121.669H64.287V114.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M70.2109 114.727H66.585V121.669H70.2109V114.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M76.1396 114.727H72.5137V121.669H76.1396V114.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M82.0683 114.727H78.4424V121.669H82.0683V114.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M87.9921 114.727H84.3662V121.669H87.9921V114.727Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M83.9767 105.443H58.752V107.092H83.9767V105.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M83.9767 101.541H58.752V103.19H83.9767V101.541Z",
    fill: "white"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9767 97.6406H58.752V99.2893H83.9767V97.6406Z",
    fill: "#00A0F3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M153.439 63.1582H126.139V126.09H153.439V63.1582Z",
    fill: "#00A0F3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M153.439 63.1591H126.139L130.507 54.9258H149.071L153.439 63.1591Z",
    fill: "#00A0F3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.531 50.4785H135.052V54.9254H144.531V50.4785Z",
    fill: "#00A0F3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 65.9961H128.77V66.8482H150.808V65.9961Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 69.6875H128.77V70.5396H150.808V69.6875Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 73.3789H128.77V74.231H150.808V73.3789Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 77.0684H128.77V77.9204H150.808V77.0684Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 80.7598H128.77V81.6118H150.808V80.7598Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 84.4492H128.77V85.3013H150.808V84.4492Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 88.1465H128.77V88.9986H150.808V88.1465Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 91.8359H128.77V92.688H150.808V91.8359Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 95.5273H128.77V96.3794H150.808V95.5273Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 99.2168H128.77V100.069H150.808V99.2168Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 102.908H128.77V103.76H150.808V102.908Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 106.6H128.77V107.452H150.808V106.6Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 110.289H128.77V111.141H150.808V110.289Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 113.98H128.77V114.833H150.808V113.98Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.808 117.67H128.77V118.522H150.808V117.67Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.7546 71.331C30.5254 71.3322 30.2981 71.3731 30.0829 71.452C30.1893 71.1264 30.2439 70.7861 30.2445 70.4436C30.2445 69.5464 29.8875 68.6859 29.2521 68.0514C28.6166 67.417 27.7547 67.0605 26.856 67.0605C25.9573 67.0605 25.0954 67.417 24.4599 68.0514C23.8245 68.6859 23.4674 69.5464 23.4674 70.4436C23.4674 70.5344 23.4674 70.6201 23.4674 70.7108C23.1256 70.5345 22.7463 70.4428 22.3615 70.4436C22.0302 70.4286 21.6992 70.4808 21.3887 70.597C21.0781 70.7133 20.7943 70.8911 20.5546 71.1199C20.3148 71.3487 20.1239 71.6236 19.9935 71.9281C19.8631 72.2326 19.7959 72.5603 19.7959 72.8914C19.7959 73.2226 19.8631 73.5503 19.9935 73.8547C20.1239 74.1592 20.3148 74.4341 20.5546 74.6629C20.7943 74.8917 21.0781 75.0696 21.3887 75.1858C21.6992 75.3021 22.0302 75.3543 22.3615 75.3392H30.7546C31.0411 75.38 31.3329 75.3588 31.6105 75.2772C31.888 75.1955 32.1448 75.0553 32.3633 74.866C32.5819 74.6767 32.7572 74.4427 32.8773 74.1799C32.9974 73.9171 33.0596 73.6315 33.0596 73.3427C33.0596 73.0538 32.9974 72.7683 32.8773 72.5055C32.7572 72.2427 32.5819 72.0087 32.3633 71.8194C32.1448 71.63 31.888 71.4898 31.6105 71.4082C31.3329 71.3265 31.0411 71.3054 30.7546 71.3461V71.331Z",
    fill: "#DDDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreWallet);
export default __webpack_public_path__ + "static/media/MoreWallet.95fc12ae44b5216e0b8d400f2e1ff17a.svg";
export { ForwardRef as ReactComponent };